import React from 'react';
import Text from '../../../../../../global/text/text';
import { IAttendeeAdditionalInfo } from '../_attendee';
import './attendee-presentation.scss';
import { Permission } from '../../../../../../../api/roles.dao';
import { hasPermission } from '../../../../../../../infrastructure/utils/has-permissions';
import { CopyButton } from '../../../../../../global/copy-button/copy-button';
import { FormattedMessage } from 'react-intl';
import { REMOVE_TEXT } from '../../../../../../../constants/common-labels.constants';

export interface IProps {
    attendeeInfo: IAttendeeAdditionalInfo;
    handleClick: () => void;
    handleRemoveClick?: () => void;
    withRemove?: boolean;
    handleCopy?: () => void;
    editPermission?: Permission;
}

export function AttendeeAdditionalInfo(props: IProps) {
    const { attendeeInfo, handleClick, handleRemoveClick, withRemove = false, handleCopy, editPermission = Permission.UPDATE_ATTENDEE } = props;
    const copyValue = `${attendeeInfo.name} - ${attendeeInfo.organizationName}`;
    return (
        <>
            <div className='attendee-presentation'>
                {Object.values(attendeeInfo).map((value, i) => (
                    i === 0
                        ? (
                            value && (
                                <div
                                    key={`${value}_${i}`}
                                    className='copy-name-wrap m-bottom-5px'
                                    style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
                                >
                                    <Text key={i} tag='p' message={value} withEllipsis escapeHtml={true} className='line-height-25px m-bottom-0px' />
                                    <CopyButton withoutIcon copyValue={copyValue} onCopy={handleCopy} className='m-left-5px' />
                                </div>
                            ))
                        : value && <Text key={i} tag='p' message={value} withEllipsis escapeHtml={true}/>
                ))}
                {hasPermission(editPermission) &&
                    <button
                        onClick={handleClick}
                        type='button'
                        className='default-button default-button--slim visible-while-hovered'
                    >
                        <span>Edit</span>
                    </button>}
            </div>
            {withRemove &&
                <div
                    className='popup-footer-remove-button attendee-presentation-footer'
                    onClick={handleRemoveClick}
                >
                    <FormattedMessage {...REMOVE_TEXT} />
            </div>}
        </>
    );
}